import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AgentLegacyTransfer from '../../auth/AgentLegacyTransfer';
import { AGENT_PIN_ENABLED, AGENT_REGISTERED_RECEIVER_AMOUNT, VERITASON_AGENT_WALLET_TRANSFER_ENABLED } from '../../config/features';
import VeritasonTransferModal from './VeritasonTransferModal';
import { buildWalletWithdrawalRequest } from './walletWithdrawal';
import { lookupAgentAccountHolder, transferAgentWallet, registeredAgentAccount, queryAgentRequest, listUnresolvedAgentRequests } from './agentWalletTransfer';

// Accept the same balance response from either host page. Unknown available funds
// stay unknown: current_balance is not a substitute for available_balance.
export function normalizeAgentWallet(raw = {}) {
    const bal = raw.balance && typeof raw.balance === 'object' ? raw.balance : {};
    return {
        ...raw,
        available_balance: bal.available_balance ?? raw.available_balance ?? raw.availableBalance ?? null,
        current_balance: bal.total_balance ?? bal.current_balance ?? raw.current_balance ?? raw.currentBalance ?? null,
        frozen_balance: bal.locked_balance ?? raw.frozen_balance ?? raw.frozenBalance ?? raw.locked_balance ?? raw.lockedBalance ?? 0,
        locked_balance: bal.locked_balance ?? raw.locked_balance ?? raw.lockedBalance ?? 0,
        pending_deposit_amount: bal.pending_deposit ?? raw.pending_deposit_amount ?? raw.pendingDepositAmount ?? 0,
        withdrawn_amount: bal.total_withdraw ?? raw.withdrawn_amount ?? raw.withdrawnAmount ?? 0,
        account: raw.account || { bank_cd: raw.bank_cd, bank_nm: raw.bank_nm || raw.bank_name, accnt_no: raw.accnt_no || raw.account_number, accnt_nm: raw.accnt_nm || raw.account_holder },
    };
}

// Both the wallet page and earnings dashboard open this component in place.
// Route changes only happen when the user explicitly requests history/PIN setup.
export default function AgentWalletTransfer({ user, balance, onClose, onRefresh, onHistory }) {
    const navigate = useNavigate();
    const [pendingTransfer, setPendingTransfer] = useState(null);
    const wallet = normalizeAgentWallet(balance || {});
    const identity = user?.agent_id || user?.admin_id;
    const lookup = async recipient => {
        const result = await lookupAgentAccountHolder(recipient);
        if (result?.code === 9999) navigate('/');
        return result;
    };
    const transfer = async (amount, recipient, password, requestId, token, authorization, csrf) => {
        const body = buildWalletWithdrawalRequest(amount, recipient, null, requestId, token);
        if (authorization) body.authorization = authorization;
        const result = await transferAgentWallet(body, csrf);
        if (result.code === 9999) navigate('/');
        return result;
    };
    const common = { identity, pinEnabled: AGENT_PIN_ENABLED, currentBalance: wallet.current_balance, registeredAccount: registeredAgentAccount(wallet.account), onClose, onRefresh, onRegister: () => navigate('/agentPin') };
    return VERITASON_AGENT_WALLET_TRANSFER_ENABLED
        ? <VeritasonTransferModal {...common} restorePending onQuery={queryAgentRequest} onList={listUnresolvedAgentRequests} withdrawable={wallet.available_balance} withdrawalFee={wallet.withdrawal_fee} onLookup={lookup} onTransfer={transfer} pendingTransfer={pendingTransfer} onPendingChange={setPendingTransfer} />
        : <AgentLegacyTransfer {...common} receiverAmount={AGENT_REGISTERED_RECEIVER_AMOUNT} balance={wallet.available_balance} fee={wallet.withdrawal_fee} onHistory={onHistory} />;
}
